import * as React from "react";
import {VeboxExpandable} from "../../../../../components/expadable/VeboxExpandable";
import './styles.scss'

export const StatusDescriptionTooltip: React.FC = (props) => {

    const ref = React.useRef<HTMLDivElement>(null);

    const [marginTop, setMarginTop] = React.useState(0);

    React.useEffect(() => {

        if (ref.current) {
            const element = ref.current;
            const parent = element.parentElement;

            const contained = parent.scrollTop < element.offsetTop && element.offsetTop + element.clientHeight < parent.scrollTop + parent.clientHeight;

            setMarginTop(contained ? 0 : -46 - element.offsetHeight);
        }

    }, []);

    return (
        <div
            ref={ref}
            className={marginTop === 0 ? "bottom-tooltip" : "top-tooltip"}
            style={{marginTop}}
        >
            {props.children}
        </div>
    )
}


export const StatusInfo: React.FC<{
    description?: string;
}> = ({description}) => {
    const collapsed = (expanded, setExpanded) => {
        const show = () => setExpanded(true);
        const hide = () => setExpanded(false);
        return (
            <span onMouseOver={show} onMouseOut={hide} className={`material-symbols-outlined`}>info</span>
        );
    }
    return (
        <VeboxExpandable
            collapsed={collapsed}
        >
            <StatusDescriptionTooltip>
                {description}
            </StatusDescriptionTooltip>
        </VeboxExpandable>
    )
}